import React from 'react';
import { InputNumber } from 'antd';
import type { FJ750 } from '../../../services/pwj220Api';

interface Props {
  formData: Partial<FJ750>;
  isEditing: boolean;
  onChange: (field: keyof FJ750, value: any) => void;
}

const LAYER_TYPES: Record<number, string> = {
  1: '2 LAYER',
  2: '3 LAYER',
  3: '其他',
};


const Tab2FabricInfo: React.FC<Props> = React.memo(({ formData, isEditing, onChange }) => {
  const val = (f: keyof FJ750) => (formData[f] ?? '') as string;
  const numVal = (f: keyof FJ750) => (formData[f] ?? 0) as number;

  return (
    <div className="form-grid">
      {/* 面布 */}
      <h4 className="section-title">面布</h4>
      <div />

      <label>面布產品代號</label>
      <div className="inline-group">
        <input
          data-contract-field="fj750_211"
          value={val('fj750_211')}
          maxLength={6}
          onChange={e => onChange('fj750_211', e.target.value)}
          disabled={!isEditing}
          className="form-input code6"
          placeholder="前6碼"
        />
        <input
          value={val('fj750_212')}
          maxLength={6}
          onChange={e => onChange('fj750_212', e.target.value)}
          disabled={!isEditing}
          className="form-input code6"
          placeholder="後6碼"
        />
      </div>

      <label>面布組織規格</label>
      <textarea
        data-contract-field="fj750_22"
        value={val('fj750_22')}
        onChange={e => onChange('fj750_22', e.target.value)}
        disabled={!isEditing}
        className="form-textarea"
        rows={2}
      />

      <label>面布成本</label>
      <div className="inline-group">
        <InputNumber
          data-contract-field="fj750_23"
          value={numVal('fj750_23')}
          onChange={v => onChange('fj750_23', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <input
          value={val('fj750_24')}
          onChange={e => onChange('fj750_24', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="單位"
        />
        <input
          value={val('fj750_25')}
          onChange={e => onChange('fj750_25', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="貨幣"
        />
      </div>

      {/* 底布 */}
      <h4 className="section-title">底布</h4>
      <div />

      <label>底布產品代號</label>
      <div className="inline-group">
        <input
          data-contract-field="fj750_311"
          value={val('fj750_311')}
          maxLength={6}
          onChange={e => onChange('fj750_311', e.target.value)}
          disabled={!isEditing}
          className="form-input code6"
          placeholder="前6碼"
        />
        <input
          value={val('fj750_312')}
          maxLength={6}
          onChange={e => onChange('fj750_312', e.target.value)}
          disabled={!isEditing}
          className="form-input code6"
          placeholder="後6碼"
        />
      </div>

      <label>底布組織規格</label>
      <textarea
        data-contract-field="fj750_32"
        value={val('fj750_32')}
        onChange={e => onChange('fj750_32', e.target.value)}
        disabled={!isEditing}
        className="form-textarea"
        rows={2}
      />

      <label>底布成本</label>
      <div className="inline-group">
        <InputNumber
          data-contract-field="fj750_33"
          value={numVal('fj750_33')}
          onChange={v => onChange('fj750_33', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <input
          value={val('fj750_34')}
          onChange={e => onChange('fj750_34', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="單位"
        />
        <input
          value={val('fj750_35')}
          onChange={e => onChange('fj750_35', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="貨幣"
        />
      </div>

      {/* 膜 */}
      <h4 className="section-title">膜</h4>
      <div />

      <label>膜成品代號</label>
      <input
        data-contract-field="fj750_41"
        value={val('fj750_41')}
        onChange={e => onChange('fj750_41', e.target.value)}
        disabled={!isEditing}
        className="form-input"
      />

      <label>膜成本</label>
      <div className="inline-group">
        <InputNumber
          data-contract-field="fj750_42"
          value={numVal('fj750_42')}
          onChange={v => onChange('fj750_42', v || 0)}
          disabled={!isEditing}
          className="form-input"
        />
        <input
          value={val('fj750_43')}
          onChange={e => onChange('fj750_43', e.target.value)}
          disabled={!isEditing}
          className="form-input narrow"
          placeholder="單位"
        />
      </div>

      {/* 層數 (Page2) */}
      <h4 className="section-title">層數</h4>
      <div />

      <label>織物層數</label>
      <div className="inline-group">
        <select
          data-contract-field="fj750_44"
          value={numVal('fj750_44')}
          onChange={e => onChange('fj750_44', parseInt(e.target.value))}
          disabled={!isEditing}
          className="form-select"
        >
          {Object.entries(LAYER_TYPES).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
        {numVal('fj750_44') === 3 && (
          <input
            value={val('fj750_441')}
            onChange={e => onChange('fj750_441', e.target.value)}
            disabled={!isEditing}
            className="form-input"
            placeholder="說明"
          />
        )}
      </div>
    </div>
  );
});

export default Tab2FabricInfo;
